import { Box, Button, FormControl, Grid, InputLabel, MenuItem, Select, Stack } from '@mui/material';
import React, { useMemo, useState } from 'react';
import MDButton from 'components/MDButton';
import { useLocation, useNavigate } from 'react-router-dom';

function hasAnyValue(obj) {
  for (const key in obj) {
    if (obj.hasOwnProperty(key) && (
      (typeof obj[key] === 'object' && hasAnyValue(obj[key])) ||
      (typeof obj[key] !== 'object' && obj[key] !== '')
    )
    ) {
      return true;
    }
  }
  return false;
}

export default function FilterSubTraits(props = {}) {

  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({ selectedPlatform: '', parentTrait: '' });
  const { applyTraitFilter, parentTraits } = props;

  const clearAllHandler = () => {
    setFormData({ selectedPlatform: '', parentTrait: '' });
    navigate('/product_traits/subtrait');
    applyTraitFilter({});
  };

  const showApplyButton = useMemo(() => {
    return hasAnyValue(formData);
  }, [formData]);

  const applyFiltersHandler = () => {
    const { selectedPlatform, parentTrait } = formData || {};
    let queryPayload = {
      platformType: selectedPlatform,  // Changed from status to platforms
      parentTrait: parentTrait
    };
    if (queryPayload.platformType === 'all') {
      queryPayload = { ...queryPayload, platformType: '' };
    }
    let url = `${location.pathname}?`;
    Object.keys(queryPayload).forEach((key => {
      if (typeof queryPayload[key] === 'object') {
        url = url + `&${key}=${JSON.stringify(queryPayload[key])}`;
      } else {
        url = url + `&${key}=${queryPayload[key]}`;
      }
    }));
    const params = new URLSearchParams(url);
    const urlWithParams = `${location.pathname}?${params}`;
    navigate(urlWithParams);
    applyTraitFilter({ queryPayload });
  };

  return (
    <Box className='cus-filter-sec' mb={1}>
      <Grid className='filter-box' container alignItems='center' spacing={1.5}>
        <Grid item xs={12} sm={12} md={12} xxl={12}>
          <Box className='filter-price-unit'>
            <Stack direction='row' justifyContent='flex-start' width='100%' gap={2}>
              
              {/* Parent Traits Dropdown */}
              <Grid item xs={12} sm={4} md={2} xxl={2}>
                <Box className='filter-pro-status'>
                  <FormControl fullWidth>
                    <InputLabel>Parent Traits</InputLabel>
                    <Select
                      size='small'
                      value={formData?.parentTrait}
                      onChange={(e) => setFormData({ ...formData, parentTrait: e.target.value })}
                      fullWidth
                      className='form-select'
                      name='parentTrait'
                      label='Parent Traits'
                    >
                      {parentTraits?.map(item => (
                        <MenuItem value={item.mainTraitName} key={item._id}>{item.mainTraitName}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              {/* Platforms Dropdown */}
              <Grid item xs={12} sm={4} md={2} xxl={2}>
                <Box className='filter-pro-status'>
                  <FormControl fullWidth>
                    <InputLabel>Platform</InputLabel>
                    <Select
                      size='small'
                      value={formData?.selectedPlatform}  // Binding the platform selection
                      onChange={(e) => setFormData({ ...formData, selectedPlatform: e.target.value })}
                      fullWidth
                      className='form-select'
                      name='platforms'
                      label='Platforms'
                    >
                      <MenuItem value='all'>All</MenuItem>
                      <MenuItem value='hyperwolf'>Hyperwolf</MenuItem>
                      <MenuItem value='hemp'>Hemp</MenuItem>
                      <MenuItem value='stilo'>Stilo</MenuItem>

                    </Select>
                  </FormControl>
                </Box>
              </Grid>

              {/* Filter Buttons */}
              <Grid item xs={12} sm={4} md={4} xxl={1.5}>
                <Box className='filter-btns'>
                  <Stack direction='row' alignItems='center' gap={1} className='w-100'>
                    <Button
                      className='filter-clear-all'
                      onClick={clearAllHandler}
                      size='small'
                      variant='text'
                      color='secondary'
                      style={{ width: '100%', fontWeight: "normal" }}
                    >
                      Clear All
                    </Button>
                    <MDButton
                      disabled={!showApplyButton}
                      className='filter-apply'
                      onClick={applyFiltersHandler}
                      size='small'
                      variant='contained'
                      color='primary'
                      style={{ width: '100%' }}
                    >
                      Apply
                    </MDButton>
                  </Stack>
                </Box>
              </Grid>
            </Stack>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
}
